import {TranslationObject} from '@colonist/i18n'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {createDivIn, createExternalImgIn, createHeaderIn, createImgIn, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {LobbyImage} from '@colonist/types'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas'
import {UIMGameMode} from '../UIMGameModeController'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'
import {navigateToPage, getHomepageUrl} from '../../../shared/scripts/ui_utils/ClientUtils'
import IconHamburger from '@static/images/icon_hamburger.svg'

enum GameOrientation {
    PORTRAIT = 'PORTRAIT',
    LANDSCAPE = 'LANDSCAPE'
}

export class UIMGameModeSelectionPopup extends ViewPopup {
    private isSelectedOrientationPortrait: boolean | undefined

    constructor() {
        const title: TranslationObject = {key: 'strings:homePage.header.orientationPopup.header'}
        const body: TranslationObject = {key: 'strings:homePage.header.orientationPopup.body'}

        super(title, body, () => undefined, () => undefined, false, {showXButton: false})

        const refreshGame = async() => {
            if(this.isSelectedOrientationPortrait == undefined) return UIMDeviceHandler.showNotification({key: 'strings:homePage.header.orientationPopup.notification'})
            StorageWrapper.setTimestampUserSelectedGameMode(new Date().valueOf())

            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ClickedChangeMobileOrientation,
                category: AnalyticEventCategory.MobileAnalytics,
                stringValue: 'DEFAULT',
                floatValue: this.isSelectedOrientationPortrait ? UIMGameMode.PORTRAIT : UIMGameMode.LANDSCAPE,
            }
            await CA.sendAnalyticEvent(eventData)
            this.removePopup()
            navigateToPage(getHomepageUrl())
        }
        setElementOnClick(this.checkButton, () => refreshGame())
        this.body.style.textAlign = 'center'
        this.body.style.flexDirection = 'column'
        this.checkButton.style.opacity = '0.6'

        this.addMenuIcon()

        const radioOptions: RadioOption[] = [
            {
                value: GameOrientation.PORTRAIT,
                image: LobbyImage.PortraitIcon,
                text: {key: 'strings:colonistCommon.utils.#buffer', options: {value: 'Portrait'}},
            },
            {
                value: GameOrientation.LANDSCAPE,
                image: LobbyImage.LandscapeIcon,
                text: {key: 'strings:colonistCommon.utils.#buffer', options: {value: 'Landscape'}},
            },
        ]
        new UIImageRadioButtons(this.body, radioOptions, (option: GameOrientation) => this.onOptionToggle(option))
    }

    private onOptionToggle(option: GameOrientation) {
        const isPortrait = option == GameOrientation.PORTRAIT
        this.isSelectedOrientationPortrait = isPortrait
        StorageWrapper.setPortraitGamePlayEnabled(isPortrait)
        this.checkButton.style.fontWeight = '600'
        this.checkButton.style.opacity = '1'
    }

    private addMenuIcon() {
        const pTag = this.body.children[0] as HTMLParagraphElement
        const menuDiv = createDivIn(pTag, 'menu-icon')
        createExternalImgIn(menuDiv, IconHamburger, {key: 'strings:colonistCommon.utils.#buffer', options: {value: 'Menu Icon'}})
    }
}

interface RadioOption {
    text?: TranslationObject
    value: string | number
    image?: LobbyImage
}

class UIImageRadioButtons {
    constructor(container: HTMLDivElement, options: RadioOption[], onClick: (value: string | number) => void) {
        const radioContainer = createDivIn(container, 'radio-options-container')
        const selectedClassName = 'selected'
        const resetAllOptions = () => {
            const allChildren = Array.from(radioContainer.children)
            allChildren.forEach((child: Element) => {
                child.classList.remove(selectedClassName)
            })
        }

        options.forEach((option: RadioOption) => {
            const btn = createDivIn(radioContainer, 'radio-button')
            if(option.image != undefined) createImgIn(btn, option.image)
            if(option.text != undefined) createHeaderIn(btn, option.text, '', '', 'h3')
            setElementOnClick(btn, () => {
                resetAllOptions()
                btn.classList.add(selectedClassName)
                onClick(option.value)
            })
        })
    }
}
